import PropTypes from 'prop-types';
import React from 'react';

const OkayToShopInfo = ({ okayToShopBarcodes }) => {
  return <div id="OKTS_div" data-ean={okayToShopBarcodes.join(',')} />;
};

OkayToShopInfo.propTypes = {
  okayToShopBarcodes: PropTypes.array.isRequired,
};

export { OkayToShopInfo };
